<template xmlns="http://www.w3.org/1999/html">
  <el-dialog
    title="打印预览"
    :visible="visible"
    width="960px"
    :before-close="hideDialog"
    :close-on-click-modal="false"
    :modal="false"
    :modal-append-to-body="false"
  >
    <div id="labelListPrint">
      <el-button type="primary" @click="PrintContract" style="margin: 10px 0"
        >打 印
      </el-button>
      <!-- <el-button type="info" @click="visible=false">关 闭</el-button> -->

      <div
        ref="labelListPrint"
        id="labelListPrint"
        style="padding-top: 30px; font-family: 宋体"
      >
        <div
          style="
            text-align: center;
            font-size: 30px;
            padding: 0 0 20px;
            font-family: 仿宋_GB2312;
            font-weight: 500;
          "
        >
          {{ printData.scoreTemplate }}
        </div>

        <div style="font-size: 18px; margin-bottom: 6px">
          <div style="display: inline-block; width: 100px">填报单位：</div>
          <div
            contenteditable="true"
            style="display: inline-block; width: calc(100% - 270px)"
          >
            {{ printData.applyDeptNamePrint }}
          </div>
          <div
            contenteditable="true"
            style="display: inline-block; text-align: right"
          >
            时间：{{ printData.duptDeptCommentTime?printData.duptDeptCommentTime.substring(0,10):''}}
          </div>
        </div>
        <div
          style="border: 1px solid rgb(0, 0, 0); margin: 4px 0; font-size: 16px"
        >
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0);
              display: flex;
              min-height: 42px;
            "
          >
            <div
              style="
                width: 100px;
                border-right: 1px solid rgb(0, 0, 0);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              合同单位名称
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ printData.supplierName }}
            </div>
            <div
              style="
                width: 100px;
                border-right: 1px solid rgb(0, 0, 0);
                border-left: 1px solid rgb(0, 0, 0);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              注册资金
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ printData.registeredCapital }}
            </div>
          </div>
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0);
              display: flex;
              min-height: 42px;
            "
          >
            <div
              style="
                width: 100px;
                border-right: 1px solid rgb(0, 0, 0);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              负责人
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ printData.legalPerson }}
            </div>
            <div
              style="
                width: 100px;
                border-right: 1px solid rgb(0, 0, 0);
                border-left: 1px solid rgb(0, 0, 0);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              资质等级
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ printData.qualificationLevel }}
            </div>
          </div>
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0);
              display: flex;
              min-height: 68px;
            "
          >
            <div
              style="
                width: 100px;
                border-right: 1px solid rgb(0, 0, 0);
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
              "
            >
              <span style="padding: 0 12px"> 合作单位简介 </span>
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ printData.supplierDescPrint }}
            </div>
          </div>
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0, 0.6);
              display: flex;
              min-height: 40px;
            "
          >
            <div
              contenteditable="true"
              style="
                width: 80px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              评审项目
            </div>

            <div
              contenteditable="true"
              style="
                width: 360px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              评审内容
            </div>
            <div
              style="
                width: 50px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              分值
            </div>

            <div
              style="
                width: 110px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              扣分原因
            </div>
            <div
              style="
                width: 50px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              扣分
            </div>

            <div
              style="
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              得分
            </div>
          </div>
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0, 0.6);
              display: flex;
              min-height: 40px;
              page-break-inside: avoid;
            "
            v-for="item in tableData"
            :key="item.subCategoryNo"
          >
            <div
              contenteditable="true"
              style="
                width: 80px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                word-break: break-all;
                justify-content: center;
              "
            >
              {{ item.project }}
            </div>

            <div
              contenteditable="true"
              style="
                width: 360px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                white-space: pre-wrap;
                text-indent: 0;
              "
            >
              <span style="padding: 2px">{{ item.content }}</span>
            </div>
            <div
              style="
                width: 50px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              {{ item.totalScore }}
            </div>

            <div
              style="
                width: 110px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              {{ item.reason }}
            </div>
            <div
              style="
                width: 50px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              {{ item.deduct }}
            </div>

            <div
              style="
                display: flex;
                flex: 1;
                align-items: center;
                justify-content: center;
              "
            >
              {{ item.score }}
            </div>
          </div>
          <!-- <div style="display: flex; min-height: 40px">
            <div
              contenteditable="true"
              style="
                width: 482px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              合计
            </div>
            <div
              style="
                width: 60px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            ></div>

            <div
              style="
                width: 130px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            ></div>
            <div
              style="
                width: 60px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            ></div>

            <div
              style="
                width: 60px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            ></div>
          </div> -->
          <div
            style="
              display: flex;
              flex-direction: column;
              min-height: 100px;
              border-bottom: 1px solid rgb(0, 0, 0, 0.6);
            "
          >
            <div style="display: flex; margin: 2px">
              生产部门综合评定意见：(分为优秀、良好、合格、不合格）：
            </div>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                min-height: 68px;
              "
            >
              {{ opts[printData.productDeptLevel] }}
            </div>
            <div
              style="
                display: flex;
                justify-content: flex-end;
                margin-right: 20px;
                margin-bottom: 4px;
              "
            >
              <div>生产部门负责人:</div>
              <!-- <div
                    v-if="printData.handleChargeUserSign"
                    style="
                      padding: 4px;
                      margin: 2px 10px 0 0;
                    "
                  >
                    <img
                      :src="printData.handleChargeUserSign"
                      width="100px"
                      height="48px"
                    />
                  </div>
                  <div
                    v-else
                    contenteditable="true"
                  >
                    {{ printData.legalPerson }}
                  </div> -->
              <div style="margin-left: 160px; margin-right: 100px">时间:</div>
              <!-- <div>{{ printData.duptDeptCommentTime }}</div> -->
            </div>
          </div>

          <div style="display: flex; flex-direction: column; min-height: 100px">
            <div style="display: flex; margin: 2px" v-if="printData.scoreTemplate.includes('劳务')">
              安全和工程管理部综合评定意见：(分为同意、不同意）
            </div>
            <div style="display: flex; margin: 2px" v-else>
              设备物资部综合评定意见：(分为同意、不同意）
            </div>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                min-height: 68px;
              "
            >
              {{ printData.dutyDeptComment == 1 ? "同意" : printData.dutyDeptComment == null ?"":"不同意" }}
            </div>
            <div
              style="
                display: flex;
                justify-content: flex-end;
                margin-right: 20px;
                margin-bottom: 4px;
              "
            >
              <div>部门负责人:</div>
              <!-- <div
                    v-if="printData.handleChargeUserSign"
                    style="
                      padding: 4px;
                      margin: 2px 10px 0 0;
                    "
                  >
                    <img
                      :src="printData.handleChargeUserSign"
                      width="100px"
                      height="48px"
                    />
                  </div>
                  <div
                    v-else
                    contenteditable="true"
                  >
                    {{ printData.legalPerson }}
                  </div> -->
              <div style="margin-left: 160px; margin-right: 100px">时间:</div>
              <!-- <div>{{ printData.duptDeptCommentTime }}</div> -->
            </div>
          </div>
        </div>
        <div height="20px">&nbsp;</div>
      </div>
      <div class="printWrap" v-show="false">
        <div
          v-html="labelListPrintContent"
          class="mainHtml"
          id="printlabelListPrintContent"
        ></div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import printJS from "print-js";

export default {
  name: "labelListPrint",
  props: {
    formData: {
      type: Object,
    },
    visible: {
      type: Boolean,
      defaule: false,
    },
    tableData: {
      type: Array,
    },
  },
  data() {
    return {
      approveProcessList: [],
      labelListPrintContent: null,
      opts: {
        0: "不合格",
        1: "合格",
        2: "良好",
        3: "优秀",
      },
    };
  },
  computed: {
    printData() {
      return {
        ...this.formData,
      };
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.labelListPrintContent = this.$refs.labelListPrint.innerHTML;
      this.labelListPrintContent =
        document.getElementById("labelListPrint").innerHTML;
    });
  },
  methods: {
    hideDialog() {
      this.$emit("update:visible", false);
    },
    //打印当前合同
    PrintContract() {
      this.$set(
        this,
        "labelListPrintContent",
        this.$refs.labelListPrint.innerHTML
      );
      this.$nextTick(() => {
        printJS({
          printable: "printlabelListPrintContent",
          type: "html",
          targetStyles: ["*"],
          ignoreElements: ["no-print", "bc", "gb"],
          scanStyles: false,
        });
      });
    },
  },
};
</script>
<style lang="scss">
#labelListPrint {
  // box-shadow: 0px 4px 12px 2px #bbb;
  position: relative;
  // padding: 0 10px;
  width: 21cm;
  margin: 0 auto;
}

.printWrap {
  width: 21cm;
  margin: 30px auto;
  padding: 5mm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

.mainHtml {
  width: 21cm;
}
</style>
